import { Component, Input, OnInit } from '@angular/core';
import { LoggerService } from '../../../services/logger.service';

@Component({
  selector: 'app-generic-table',
  templateUrl: './generic-table.component.html',
  styleUrls: ['./generic-table.component.css']
})
export class GenericTableComponent implements OnInit {

  // @Input() DataSource: [] = [];
  @Input() Columns;
  @Input() Rows: [] = [];

  dataSource = this.Rows;

  constructor() { }

  ngOnInit(): void {
    LoggerService.log("this.Columns")
    LoggerService.log(this.Columns)
    LoggerService.log("this.Rows")
    LoggerService.log(this.Rows)
  }

}
